import * as loyaltyAction from "../../redux/actions/loyalty";
import { store } from "../../redux/store";
import * as loyaltyRepo from "../repos/graphql/loyalty";

let loadInFlight = null;

export const getAdjustedLoyaltyPoints = (profilePoints, order) => {
  let loyaltyPoints = profilePoints;
  if (order && order?.orderRedeemables?.length > 0) {
    const usedPoints = order.orderRedeemables.reduce(
      (accumulator, currentValue) => accumulator + currentValue.points,
      0,
    );
    loyaltyPoints = profilePoints - usedPoints;
  }
  return loyaltyPoints;
};

/**
 * Loads Punchh redeemables, deals, and profile points into Redux.
 * Shared by legacy and fullscreen headers.
 */
export const loadPunchhLoyalty = async order => {
  if (!loadInFlight) {
    loadInFlight = (async () => {
    const [redeemablesRes, dealsRes, profileRes] = await Promise.all([
      loyaltyRepo.getLoyaltyRedeemables(),
      loyaltyRepo.getLoyaltyDeals(),
      loyaltyRepo.getLoyaltyProfile(),
    ]);

    store.dispatch(
      loyaltyAction.loyaltyRedeemables(redeemablesRes.data.loyaltyRedeemables),
    );
    store.dispatch(loyaltyAction.loyaltyDeals(dealsRes.data.loyaltyDeals));
    store.dispatch(
      loyaltyAction.loyaltyPoints(
        getAdjustedLoyaltyPoints(
          profileRes.data.loyaltyProfile.points,
          order,
        ),
      ),
    );
    })();
  }

  try {
    await loadInFlight;
  } finally {
    loadInFlight = null;
  }
};
